import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { getStaffLandingPath } from "@/lib/page-permissions";

export default function StaffLanding() {
  const { user, loading } = useAuth();
  if (loading || !user) return null;
  return <Navigate to={getStaffLandingPath(user)} replace />;
}
